<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/system-users/users',
                    menuLabel: 'Users',
                    name: 'view-users',
                    permission: ['view-users', 'manage-users'],
                },
                {
                    anchorLink: '/system-users/roles',
                    menuLabel: 'Roles & Permissions',
                    name: 'view-roles',
                    permission: ['manage-roles'],
                },
                {
                    anchorLink: '/system-users/data-segments',
                    menuLabel: 'Data Segments',
                    name: 'view-data-segments',
                    permission: ['view-data-segments', 'manage-data-segments'],
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['scopes']),

        getMenuListing() {
            let arr = this.menuListing.filter((item) => {
                return this.checkPermission(item.permission)
            })

            return arr
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        checkPermission(scopes) {
            return !!_.intersection(scopes, this.scopes).length
        },
    }, // End of Component > mounted
} // End of export default
</script>
